




import Vue from 'vue';
import Component from 'vue-class-component';

import SavvyFlow from '../../components/util/Savvy/SavvyFlow.vue';
import { mapGetters } from 'vuex';

@Component({
  components: { SavvyFlow },
  computed: {
    ...mapGetters('savvyPage', ['savvyPage', 'savvyId']),
  },
})
export default class SavvyPage extends Vue {
  private savvyId!: string;
}
